//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "SMARTCOP",
  data() {
    return {
      form: {
        systolic_pressure: "0",
        x_ray: "0",
        serum: "0",
        breathe: "0",
        heartRate: "0",
        disturbance: "0",
        hypoxemia: "0",
        ph: "0",
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      console.log(form,'form1');
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      console.log(form,'form');
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // diabetes + hypertension + ageOver60 + clinic + duration  + (dual ? 2 : 0) + (mri ? 2 : 0) + (stenosis ? 2 : 0)
        let result =
          (form.systolic_pressure ? 2 : 0) +
          (form.x_ray ? 1 :0) +
          (form.serum ?1 :0 ) +
          (form.breathe ? 1:0) +
          (form.heartRate ? 1:0) +
          (form.disturbance ? 1:0) +
          (form.hypoxemia ? 2 : 0) +
          (form.ph ? 2:0) 
          ;

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SMARTCOP.vue